var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"com-text",domProps:{"innerHTML":_vm._s(_vm.dataInfo.value)},on:{"!click":function($event){return _vm.handleClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }